import axios from "axios";
import { prepareGetQuery } from "../utils/get-query";
import http from "./https";

export type User = {
  email: string;
  accessTokenMs: string;
  name: string;
  token?: any;
};

export type Invitation = {
  email: string;
  role: string;
};

export type ChangeStatus = {
  email: string;
  deactivated: boolean;
};

export type Pagination = {
  take: number;
  skip: number;
  sortDesc: boolean;
  sortBy: string;
};

export type FilterLog = {
  take: number;
  skip: number;
  sortDesc: boolean;
  sortBy: string;
  filterBy?: string;
  filterValue?: string;
  filterStartDate?: any;
  filterEndDate?: any;
};

export type CurrencyUpdate = {
  variance?: number;
  varianceStartAt?: Date;
  varianceEndAt?: Date;
  public?: boolean;
  active?: boolean;
  index?: number;
};

export type CreateCurrency = {
  variance?: number;
  varianceStartAt?: Date;
  varianceEndAt?: Date;
  code: string;
  name: string;
};

export type FindExchangeRate = {
  take?: number;
  skip: number;
  sortDesc: boolean;
  sortBy: string;
  currencyCode?: string;
  startAt?: number;
  endAt?: number;
};

export type ExchangeRateUpdate = {
  variance?: number;
  sellingPrice?: number;
  buyingPrice?: number;
};
//-----------------------------------------------USER MODULE-----------------------------------------------------------------
//login with o365 account
export const loginWithO365 = async (user: User) => {
  const result = await http.post<User>("/users", user);
  return result;
};

//send invitation
export const sendInvitation = async (invitation: Invitation) => {
  const result = await http.post<Invitation>("/users/invite", invitation);
  return result;
};

//get users
export const getUsers = async (pagination: Pagination) => {
  const result = await http.get<Pagination>(
    `/users/${prepareGetQuery({ ...pagination })}`
  );
  return result;
};

//get users
export const changeStatus = async (changeStatus: ChangeStatus) => {
  const result = await http.put<any>("/users", changeStatus);
  return result;
};

//-----------------------------------------------CURRENCY MODULE-----------------------------------------------------------------
//get currency
export const getCurrencies = async (pagination: Pagination) => {
  const result = await http.get<Pagination>(
    `/currencies/${prepareGetQuery({ ...pagination })}`
  );
  return result;
};

// update currency
export const updateCurrency = async (
  code: string,
  currencyUpdate: CurrencyUpdate
) => {
  const result = await http.put<any>(`/currencies/${code}`, currencyUpdate);
  return result;
};

// update currency
export const createCurrency = async (body: CreateCurrency) => {
  const result = await http.post<any>("/currencies", body);
  return result;
};

// get history edit variance
//get currency
export const getHistoryEditVariance = async (
  pagination: Pagination,
  code: string
) => {
  const result = await http.get<Pagination>(
    `/currencies/history-edit/${code}/${prepareGetQuery({ ...pagination })}`
  );
  return result;
};

//-----------------------------------------------AUDIT LOGS MODULE-----------------------------------------------------------------

// get audit logs
export const getAuditLogs = async (pagination: FilterLog) => {
  const result = await http.get<FilterLog>(
    `/audit-logs/${prepareGetQuery({ ...pagination })}`
  );

  return result;
};

//-----------------------------------------------EXCHANGE RATE MODULE-----------------------------------------------------------------

// get exchange rates
export const getExchangeRate = async (findExchangeRate: FindExchangeRate) => {
  const result = await http.get<FindExchangeRate>(
    `/exchange-rates/${prepareGetQuery({ ...findExchangeRate })}`
  );
  return result;
};

// export report
export const exportReport = async (findExchangeRate: FindExchangeRate) => {
  let token = "";
  const user = localStorage.getItem("infoSignin");
  if (user) {
    try {
      const parse = JSON.parse(user);
      if (parse?.accessToken !== undefined) {
        token = parse.accessToken;
      }
    } catch (error) {}
  }
  const response = await axios.get(
    `${
      process.env.REACT_APP_BACKEND_URL
    }/exchange-rates/report/${prepareGetQuery({
      ...findExchangeRate,
    })}`,
    {
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "data.csv"); //or any other extension
  document.body.appendChild(link);
  link.click();
  return response.data;
};

// update exchange rate
export const updateExchangeRate = async (
  id: string,
  exchangeRateUpdate: ExchangeRateUpdate
) => {
  const result = await http.put<ExchangeRateUpdate>(
    `/exchange-rates/${id}`,
    exchangeRateUpdate
  );
  return result;
};

// get exchange rates
export const getExchangeRateExternal = async (date: number) => {
  const result = await http.get<any>(`/exchange-rates/external/${date}`);
  return result;
};

